/*eslint-disable no-underscore-dangle, no-unused-vars */
/*globals window, Raven */
(function iife() {
	"use strict";

	// Raven.Plugins.Angular needs to be installed before setting ngRaven as a dependency for digiexam
	// Installing Raven.Plugins.Angular creates the ngRaven module
	Raven.config("https://8ca2ef6d61514153aae171e803e7ba42@sentry.io/1189776", {
		release: DX.version, // eslint-disable-line no-undef
		maxMessageLength: 1000,
		dataCallback: function ravenStripPasswords(data) {
			if (data &&
				data.extra &&
				data.extra.config &&
				data.extra.config.data &&
				data.extra.config.data.password) {
				data.extra.config.data.password = "**HIDDEN**";
			}

			return data;
		},
	}).addPlugin(Raven.Plugins.Angular).install();
}());
